import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gSteps from "@/components/g-steps/g-steps.vue"
import gDataTable from "@/components/g-data-table/g-data-table.vue"
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import CartaPropostaController from "@/shared/controllers/cartaProposta/CartaPropostaController"


export default {
  name:'GerarCartaPropostaOrcamento',
  components:{
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton,
    'g-steps': gSteps,
    'g-data-table': gDataTable,

  },
  setup(){
    return {
      v$: useVuelidate()
    }
  },

  mounted(){
    
    //primeiro vemos se se trata de uma carta que é uma nova versão
    this.VerificarCartaNovaVersao()

    
    
    // this.popularGrid()
    // this.populaCartaPropostaOrcamento()
    var cartaId =  this.$route.params.id
    this.CartaPropostaId = cartaId
    this.ImagemEmpresa()

  },


  updated() {


  },

  data () {
    return {
        popup: false,
        imagemEmpresa: '',

        CartaPropostaId: null,

        colunasTabelastep1 :[
          {field: 'numeroSolicitacao', header: 'Nº Solicitação', width: '180px', ordena: true},
          {field: 'nomeProduto', header: 'Nome do Produto', width: '200px', ordena: true},
          {field: 'dataDigitacaoFormatada', header: 'Data', width: '120px', ordena: true},
          {field: 'autorizacao', header: 'Autorizacao', width: '110px', ordena: true},
          {field: 'prazoMaximo', header: 'Prazo Maximo', width: '120px', ordena: true},
          {field: 'formaDePagamento', header: 'Cond. Pgto', width: '180px', ordena: true},
          {field: 'prazoMedio', header: 'Prazo Medio', width: '120px', ordena: true},
          {field: 'porcentagemFinanceira', header: '% Financeira', width: '120px', ordena: true},
        ],

        Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS}, //permite buscar por colunas específicas
          'numeroSolicitacao': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeProduto': {value: null, matchMode: this.filtros.CONTAINS},
          'dataDigitacaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'autorizacao': {value: null, matchMode: this.filtros.CONTAINS},
          'prazoMaximo': {value: null, matchMode: this.filtros.CONTAINS},
          'formaDePagamento': {value: null, matchMode: this.filtros.CONTAINS},
          'prazoMedio': {value: null, matchMode: this.filtros.CONTAINS},
          'porcentagemFinanceira': {value: null, matchMode: this.filtros.CONTAINS},
        },
        OrcamentoArray : [],
        listaOrcamentoIds : [],
        listaFormasPagamento : [],
        listaDataFimEntrega: []
    }
  },


  validations() {
    return {
      listaOrcamentoIds:{
        required: helpers.withMessage('É preciso escolher pelo menos um Orçamento', required),
      }
    }
  },


  methods: {
    TrazerOrcamentosCartaNovaVersao(){
      this.$isLoading(true)
      this.axios({
        method: 'Get',
        url: process.env.VUE_APP_WEB_API +  `CartaProposta/TrazerOrcamentosCartaNovaVersao/${this.$route.params.id}`,
        data: {
          CartaPropostaId: this.$route.params.id
        }
      })
      .then((response) => {  
        this.$isLoading(false)
        this.OrcamentoArray = response.data.data
        this.$refs.tabela.linhasSelecionadas = response.data.data

         
      })
      .catch(() => {
      });
    },
    VerificarCartaNovaVersao(){
      this.$isLoading(true)
      this.axios({
        method: 'Get',
        url: process.env.VUE_APP_WEB_API +  `CartaProposta/VerificarCartaNovaVersao/${this.$route.params.id}`,
        data: {
          CartaPropostaId: this.$route.params.id
        }
      })
      .then((response) => {  
        this.$isLoading(false)

        //se for uma nova versão ele traz somente os orçamentos da carta que ele ta se baseando
        if(response.data.data == true)
        {
          this.TrazerOrcamentosCartaNovaVersao()

        }
        //se nao, ele vai trazer os orcamentos liberados normalmente
        else{
             this.popularGrid()
        }
      })
      .catch(() => {
      });
    },
    ImagemEmpresa(){
      CartaPropostaController.GetNomeEmpresaByCartaId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    popularGrid(){
      this.$isLoading(true)
      this.axios({
        method: 'Get',
        url: process.env.VUE_APP_WEB_API +  `CartaProposta/GetOrcamentoLiberadoCartaProposta/${this.$route.params.id}`,
        data: {
          CartaPropostaId: this.$route.params.id
        }
      })
      .then((response) => {  
        this.$isLoading(false)
        this.OrcamentoArray = response.data.data

        this.populaCartaPropostaOrcamento()
      })
      .catch(() => {
      });
    },


    adicionaNoArray(){
      this.listaOrcamentoIds = []
      this.$refs.tabela.linhasSelecionadas.forEach(obj=>{
        this.listaOrcamentoIds.push(obj.orcamentoId)
      },
      )

    
    },

    populaCartaPropostaOrcamento(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + (`CartaProposta/GetOrcamentosSelecionados/${this.$route.params.id}`),
      })
      .then((Response) => {
        this.$isLoading(false)
        this.$refs.tabela.linhasSelecionadas = Response.data.data
        })
        .catch(() => {
        })
      },

    insertCartaPropostaOrcamento(){
      this.$isLoading(true)
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API +  `CartaProposta/PostCartaPropostaOrcamento`,
        data: {
          CartaPropostaId: this.$route.params.id,
          ListaOrcamentosId: this.listaOrcamentoIds
        }
      })
      .then((response) => {
        this.$isLoading(false)
        this.CartaOrcamentoArray = response.data.data

        this.$router.push(`/gerar-carta-proposta/${this.$route.params.id}/pagamento`)

      })
      .catch(() => {
      });
    },


    step2 () {
      this.adicionaNoArray()

      if(this.v$.$invalid == true){
          this.v$.$silentErrors.forEach(error=>{
            this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
          })
        }else
        {

          let EhIgualFormaPagamento = this.$refs.tabela.linhasSelecionadas.map((i) => i.formaDePagamento).every((i) => i == this.$refs.tabela.linhasSelecionadas[0].formaDePagamento)

                                        
          let EhIgualDataFimEntrega = this.$refs.tabela.linhasSelecionadas
                                      .map((i) => i.dataFimEntregaFormatada)
                                      .every((i) => i == this.$refs.tabela.linhasSelecionadas[0].dataFimEntregaFormatada) 
          
          
          
          if (EhIgualFormaPagamento == true && EhIgualDataFimEntrega == true)
          {
            this.insertCartaPropostaOrcamento()

          }
          else{

            if (EhIgualFormaPagamento == false && EhIgualDataFimEntrega == false)
            {
              this.$toast.add({ severity: 'error', summary: 'Não é possível escolher orçamentos com condições de pagamento diferentes', life: 5000 });
              this.$toast.add({ severity: 'error', summary: 'Não é possível escolher orçamentos com datas de entrega diferentes', life: 5000 });
              return
            }
            if (EhIgualFormaPagamento == false)
            {
              this.$toast.add({ severity: 'error', summary: 'Não é possível escolher orçamentos com condições de pagamento diferentes', life: 5000 });
              return
            }
            if (EhIgualDataFimEntrega == false)
            {
              this.$toast.add({ severity: 'error', summary: 'Não é possível escolher orçamentos com datas de entrega diferentes', life: 5000 });
              return
            }
          }

        // this.insertCartaPropostaOrcamento()
        // this.$router.push(`/gerar-carta-proposta/${this.$route.params.id}/pagamento`)
       }
      },

    VoltarInicio () {
        this.$router.push(`/gerar-carta-proposta-inicio`)

      },
    popUP () {
        this.popup=true
      },

    fechapopup(){
        this.popup=false
      }
  }
}